import type { RefObject } from "react";

export type FocusTargetRef = RefObject<HTMLElement | null>;

export type FocusOnSuperKOptions = {
  preventDefault?: boolean;
  /** CSS selector used to find the focusable element inside the ref container. */
  selector?: string;
  /** Whether to select the input text after focusing (only if target is an HTMLInputElement). */
  selectText?: boolean;
};

/**
 * Generic handler for the "Super/Meta + <key>" shortcut.
 *
 * Usage (inside a keydown listener):
 * `focusOnSuperKey(event, ref, "k")`
 */
export const focusOnSuperKey = (
  event: KeyboardEvent,
  targetRef: FocusTargetRef,
  key: string,
  { preventDefault = true, selector = "input", selectText = true }: FocusOnSuperKOptions = {},
): boolean => {
  if (!event.metaKey) return false;
  if (event.key.toLowerCase() !== key.toLowerCase()) return false;

  if (preventDefault) event.preventDefault();

  const element = targetRef.current?.querySelector(selector) as HTMLElement | null;
  element?.focus();

  if (selectText && element instanceof HTMLInputElement) {
    element.select();
  }

  return true;
};
